module.exports = __webpack_public_path__ + "static/media/Kuala-lumpur-azlan-baharudin.4dfc8120.jpg";